import { api } from '@/client/utils'

export const updateContact = async (locale: string, data) => {
  const url = `/contact/create`
  return await api.post(url, JSON.stringify(data))
}
